export enum TraitementDuplicataFicheImpantation_Statut {
    EnAttenteDeTraitement,
    EnCoursDeTraitement,
    Traite
}

export function TraitementDuplicataFicheImpantation_Statut_ToText(input: TraitementDuplicataFicheImpantation_Statut) {
    switch (input) {
        case TraitementDuplicataFicheImpantation_Statut.EnAttenteDeTraitement:
            return 'Nouveau'
        case TraitementDuplicataFicheImpantation_Statut.EnCoursDeTraitement:
            return 'En cours de traitement'
        case TraitementDuplicataFicheImpantation_Statut.Traite:
            return 'Traité'
    }
}
